import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { IonicModule } from '@ionic/angular';
import { StoreModule } from '@ngrx/store';
import { CreateLeadSourceTagEffects } from './effects/create-lead-source-tag.effects';
import { LoadLeadSourceTagsEffects } from './effects/load-lead-source-tags.effects';
import { LeadSourceTagsContainerComponent } from './containers/lead-source-tags-container/lead-source-tags-container.component';
import * as fromLeadSourceTags from './reducers/lead-source-tags.reducer';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  declarations: [LeadSourceTagsContainerComponent],
  imports: [
    CommonModule,
    IonicModule,
    StoreModule.forFeature(fromLeadSourceTags.featureKey, fromLeadSourceTags.reducer),
    EffectsModule.forFeature([CreateLeadSourceTagEffects, LoadLeadSourceTagsEffects]),
    SharedModule,
  ],
  exports: [LeadSourceTagsContainerComponent],
})
export class LeadSourceTagsModule {}
